import {QUERY_KEY_GRAPHHOPPER_ROUTE} from "@containers/graphhopper/hooks/constants";

export const buildQueryKeyGraphhopper = (points:{
    lat:number,
    lng:number
}[])=>{
    return [QUERY_KEY_GRAPHHOPPER_ROUTE, points?.map((latLng) => `${latLng?.lat}.${latLng?.lng}`)?.join(','),]
}